import React, { createContext, useState } from 'react';

const GeneralGlobalStoreContext = createContext();

function GeneralGlobalStoreProvider(props) {
  const [currentMandant, setCurrentMandant] = useState(null);

  return (
    <GeneralGlobalStoreContext.Provider
      value={{ currentMandant, setCurrentMandant }}>
      {props.children}
    </GeneralGlobalStoreContext.Provider>
  );
}

export { GeneralGlobalStoreProvider, GeneralGlobalStoreContext };
